export default __webpack_public_path__ + "static/media/IMG-2736.8eb0073b.jpg";